@if (isUserSelected) {
  @if (showHeader && !isAgentDownloadUrl) {
    <app-header></app-header>
  }
  <div class="body-content">
    <router-outlet />
  </div>
}
@if (!isUserSelected || isAgentDownloadUrl) {
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.1)"
    size="default"
    color="#225EFF"
    type="ball-triangle-path" [fullScreen]="true">
  </ngx-spinner>
}

